import { render, staticRenderFns } from "./MainFeature.vue?vue&type=template&id=afd11b0c&scoped=true"
import script from "./MainFeature.vue?vue&type=script&lang=js"
export * from "./MainFeature.vue?vue&type=script&lang=js"
import style0 from "./MainFeature.vue?vue&type=style&index=0&id=afd11b0c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd11b0c",
  null
  
)

export default component.exports